<style scoped lang="scss">
  .payresult {
    text-align: center;
    .van-icon {
      margin-top: 80px;
      font-size: 70px;
    }
    .van-cell__title {
      text-align: left;
    }
    .van-cell__value {
      flex: 2;
    }
    .result_text {
      height: 60px;
      line-height: 40px;
      font-size: 18px;
    }
    .result_btn {
      width: 96%;
      margin: 10px auto;
    }
  }
</style>

<template>
  <div class="Show payresult" v-if="isShowResult">
    <van-nav-bar title="支付结果"
      left-text=""
    />
    <van-icon color="#2abd2a" name="checked" v-if="orderDetail.payStatus == 2" />
    <van-icon color="#f33737" name="clear" v-else />
    <div class="result_text">{{orderDetail.payStatusDesc}}</div>
    <van-cell-group>
      <van-cell title="订单号" :value="orderDetail.id" />
      <van-cell title="支付金额" :value="getPriceType(orderDetail.priceType).symbol + orderDetail.paymentAmount" />
      <van-cell title="交易流水" v-if="orderDetail.tradeNo" :value="orderDetail.tradeNo" />
      <van-cell title="下单时间" v-if="orderDetail.creationTime" :value="orderDetail.creationTime" />
    </van-cell-group>
    <div class="result_btn">
      <van-button type="danger" size="large" @click="toBack()">返回我的订单</van-button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'payResult',
    data() {
      return {
        isShowResult: false,
        orderId: "",
        orderDetail: {}
      }
    },
    mounted() {
      this.getPayResult()
    },
    methods: {
      getPayResult() {
        try {
          this.orderId = this.$route.params.orderId;
          if (!this.orderId || isNaN(this.orderId) || this.orderId <= 0) {
            this.$dialog.alert({ message: "禁止非法访问!" });
            return false;
          }
          this.$axios.get(window.consts.apis.payResult + "?orderId=" + this.orderId).then(res => {
            if (res.success) {
              this.getOrderDetail();
            }
          })
        } catch(e) {
          this.$toast.fail("访问错误!");
        }
      },
      getOrderDetail() {
        this.showLoading();
        this.$axios.post(window.consts.apis.queyPayInfo, {id: this.orderId}).then(res => {
            this.hideLoading();
            if (res.success) {
                let item = res.result;
                this.orderDetail = res.result;
                this.isShowResult = true;
            } else {
                this.$dialog.alert({ message: res.error.message });
                return false;
            }
        }).catch(e => {
            this.hideLoading();
            this.$toast.fail("出错啦，请稍候再试!");
            return false;
        });
      },
      toBack() {
        this.$router.push({ path: '/m/pendingpayment/0', query: { orderId: this.orderId }});
      },
      showLoading() {
          this.$toast.loading({
              duration: 0,
              forbidClick: true,
              loadingType: 'spinner',
              message: '加载中...'
          });
      },
      hideLoading() {
          this.$toast.clear()
      }
    }
  }
</script>